import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';

const Title = dynamic(() => import('components/Typography').then((m: any) => m.Title), {
  ssr: true,
}) as any;

const NoResultsMessage = ({
  header,
  message,
  helpMessage,
}: {
  header: string;
  message: string | ReactNode;
  helpMessage?: string | ReactNode;
}) => (
  <>
    <Title tag="h3" type="lg" className="mb-5">
      {header}
    </Title>
    <Title tag="p" type="xs" className="mb-9">
      {message}
    </Title>
    {helpMessage && (
      <Title tag="p" type="xs">
        {helpMessage}
      </Title>
    )}
  </>
);

export default NoResultsMessage;
